export const isInput = (element) => {
    if (!element) {
        return false;
    }
    const { tagName } = element;
    const editable = isContentEditable(element);
    return tagName === 'INPUT' || tagName === 'TEXTAREA' || editable;
};
export const inIframe = () => {
    try {
        return window.self !== window.top;
    }
    catch (_a) {
        return true;
    }
};
const isContentEditable = (element) => {
    if (typeof element.getAttribute !== 'function') {
        return false;
    }
    return !!element.getAttribute('contenteditable');
};
